<!--
   Created by qing on 2021/8/7
   Des: 数据下钻页面
-->
<template>
  <div class="form-data-container" v-wechat-title="formSet.formName">

    <div class="header">
      <div class="des">
        共{{dataHandleOpt().totalCount}}条
      </div>
      <div>
        <van-icon name="descending" @click="onClickSort"></van-icon>
        <van-icon v-if="false" name="filter-o" @click="onClickFilter"></van-icon>
      </div>
    </div>

    <div class="list-container" v-if="loadingEnd" :id="`listContainer_${tabActive}`">
      <van-list
        v-if="dataHandleOpt().styleInfo"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad">
        <div
          class="preview-container"
          :key="listKey"
          v-if="dataHandleOpt().styleInfo.showType === 'CARD'">
          <div
            class="preview-card"
            v-for="item in dataHandleOpt().dataList"
            @click="rowClick(item)"
            :key="item.instanceId">
            <div
              class="color"
              v-if="dataHandleOpt().styleInfo.showColor"
              :style="{backgroundColor : item.color ? item.color.showData : ''}">
            </div>
            <div class="preview-card-wrapper">
              <div class="card-info">
                <h3 v-if="dataHandleOpt().styleInfo.showTitle">{{item.title.showData}}</h3>
                <p v-if="dataHandleOpt().styleInfo.showTime">{{actionFormatTime(item.time.showData)}}</p>
                <div class="card-info-row">
                  <div
                    class="row-item"
                    :style="{width: `${100 / dataHandleOpt().styleInfo.showFieldList.length}%`}"
                    v-for="showData in item.content"
                    :key="showData.dataId">
                    <h5>{{showData.fieldTitle}}</h5>
                    <div class="item-content">
                      <FieldShowData :show-data="showData"></FieldShowData>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="img-container"
                v-if="dataHandleOpt().styleInfo.showImage && item.image.showData">
                <template v-if="item.image.fieldId.includes('IMAGE_')">
                  <van-image :src="item.image.showData" fit="cover"></van-image>
                </template>

                <div v-else>
                  <qriously :value="item.image.showData" :size="90"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          :key="listKey"
          class="preview-container photo-container">
          <div
            class="preview-photo"
            v-for="item in dataHandleOpt().dataList"
            :key="item.instanceId"
            @click="rowClick(item)">
            <div class="img-container" v-if="dataHandleOpt().styleInfo.showImage">
              <template v-if="item.image.showData">

                <van-image
                  v-if="item.image.fieldId.includes('IMAGE_')"
                  :src="item.image.showData"
                  fit="cover">
                </van-image>

                <div v-else>
                  <qriously :value="item.image.showData" :size="160"/>
                </div>
              </template>
              <van-image
                v-else
                :src="`${$BASE_PATH}/fetch/image?id=344442529678098433.png`"
                fit="cover">
              </van-image>
            </div>
            <div class="card-info">
              <div class="title">
                <div
                  class="color"
                  v-if="dataHandleOpt().styleInfo.showColor"
                  :style="{backgroundColor : item.color ? item.color.showData : ''}">
                </div>
                <h3 v-if="dataHandleOpt().styleInfo.showTitle">{{item.title.showData}}</h3>
              </div>
              <p v-if="dataHandleOpt().styleInfo.showTime">{{actionFormatTime(item.time.showData)}}</p>
              <div class="card-info-row">
                <div
                  class="row-item"
                  v-for="showData in item.content"
                  :key="showData.dataId">
                  <h5>{{showData.fieldTitle}}</h5>
                  <div class="item-content">
                    <FieldShowData :show-data="showData"></FieldShowData>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </van-list>
    </div>

    <div
      v-if="canApplyForm"
      class="add-button"
      @click="onClickAddForm">
       <i class="el-icon-plus"></i>
    </div>

    <form-data-filter
      :key="tabActive"
      v-if="formSet && formSet.isInit"
      ref="formDataFilter"
      :form-id="formId"
      @selectFilterComplete="actionSelectFilterComplete">
    </form-data-filter>

    <!--选择sort-->
    <van-popup
      class="select-sort-popup"
      v-model="sortVisible"
      :style="{ width: '80%' }"
      get-container="body"
      position="right">
      <div class="header">
        <span @click="clearSort">清空</span>
      </div>
      <div class="sort-container" v-if="sortVisible">
        <div v-for="item in sortFields">
          <div class="item-title">
            {{item.fieldTitle}}
            <span>{{item.sort === 1 ? '(升序)' : item.sort === -1 ? '(降序)' : ''}}</span>
          </div>
          <div class="select-sort">
            <van-radio-group v-model="item.sort">
              <van-cell-group>
                <van-cell title="升序" clickable @click="ascending(item)">
                  <template #right-icon>
                    <van-radio :name="1"/>
                  </template>
                </van-cell>
                <van-cell title="降序" clickable @click="descending(item)">
                  <template #right-icon>
                    <van-radio :name="-1"/>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
        </div>
      </div>
    </van-popup>


  </div>
</template>

<script>
  import {
    FORM_VIEW_TYPE_WRITE_FORM,
    FORM_VIEW_TYPE_DATA_HANDLE,
    FORM_VIEW_TYPE_DATA_VIEW,
    FORM_VIEW_TYPE_BOARD_VIEW
  } from "../../assets/types/index"
  import RyFormSet from '../RyForm'
  import {clone, formatDate, isIDCard, isPhone, hiddenStr} from "../../assets/js/Untis"
  import FieldShowData from "../component/FieldShowData";
  import FormDataFilter from "../component/FormDataFilter";
  import {
    DATE_TYPE__SECTION,
    FORM_ITEM__BUTTON,
    FORM_ITEM__DATE, FORM_ITEM__MEMBER,
    FORM_ITEM__RELATE_RECORD,
    FORM_TYPE__FILL
  } from "../RyForm/types";
  import {SUCCESS} from "../store/types";

  export default {
    components: {FieldShowData, FormDataFilter},
    data() {
      return {
        FORM_VIEW_TYPE_WRITE_FORM,
        FORM_VIEW_TYPE_DATA_HANDLE,
        FORM_VIEW_TYPE_DATA_VIEW,
        FORM_VIEW_TYPE_BOARD_VIEW,
        showFieldVisible: false,
        loadingEnd: false,
        sortVisible: false,
        toast: null,

        dataFilter: null,
        /*
        viewId: "writeForm"
        viewName: "填写表单"
        viewType: "writeForm"
        * */
        tabList: [],
        tabActive: 'dataHandle',
        formId: '',
        formSet: new RyFormSet(),
        dataHandleMap: {},
        hiddenListMap: {},

        loading: false,
        finished: false,
        viewSet: null,
        dataHandleOpts: {
          request: false,
          styleInfo: null,
          item: null,

          selectList: [],
          header: [],

          dataList: [],
          currentPage: 0,
          // 是否请求当页数据之前的所有数据
          allPreData: 0,
          pageSize: 20,
          totalPage: 0,
          totalCount: 0,
          sort: {},
          filter: null,
          // 当前选中的数据
          selectionList: [],
          // 滚动到指定位置
          scrollTop: 0
        },
        // 是否有发起表单权限
        canApplyForm: false,
        listKey: Math.random()
      };
    },
    async created() {
      // this.$route.query.key
      // '5eb3d2cb0069cd4a2f003906'
      this.toast = this.$toast.loading({message: '加载中...', forbidClick: true})
      const nodeValue = await this.$store.dispatch('actionWechatNodeGet', this.$route.query.key)
        .catch(err => {
          console.error(err)
        })

      this.dataFilter = nodeValue.filter

      const {
        companyId,
        userId,
        appId,
        formId
      } = this.$store.state
      this.formId = formId

      if (userId) {

        this.formSet.companyId = companyId
        this.formSet.userId = userId
        this.formSet.appId = appId
        this.formSet.formId = formId
        this.formSet.isInit = true

        this.$store.dispatch('actionMergeStructure', {
          formType: FORM_TYPE__FILL,
          viewType: 0,
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.formSet.formName = resultObject.detailInfo.formName
              this.$store.dispatch('setPageTitle', this.formSet.formName)
            } else {
              throw new Error(`${status}: ${info}`)
            }
          })
          .catch(console.error)
        await Promise.all([
          // 获取人员信息
          // this.$store.dispatch('getUserList', {
          //   userId,
          //   companyId
          // }),
          // // 获取部门信息
          // this.$store.dispatch('companyDepInfo', companyId),
          // 获取角色信息
          this.$store.dispatch('fetchRoleList', {
            userId,
            companyId
          }),
          // // 获取外部联系人
          // this.$store.dispatch('actionExternalList', {
          //   userId,
          //   companyId
          // }),
          // 获取外部联系人标签
          this.$store.dispatch('actionLabelGroupList', {
            userId,
            companyId
          }),

          this.$store.dispatch('actionLeaveMemberList'),
          this.$store.dispatch('actionLeaveExternalList'),
          // this.$store.dispatch('getCompanyOrganization'),
          this.$store.dispatch('actionCompanyDepInfo')
        ]).catch(console.error)

        // 取定位信息
        const saveJumpInfoStr = sessionStorage.getItem('saveJumpInfo')
        sessionStorage.removeItem('saveJumpInfo')
        let saveJumpInfo = null
        if (saveJumpInfoStr) {
          saveJumpInfo = JSON.parse(saveJumpInfoStr)
        }

        this.$store.dispatch('actionFetchFormViewList', {
          userId,
          companyId,
          appId,
          formId
        }).then(res => {
          if (res) {
            res.forEach(tab => {
              if (tab.viewType === FORM_VIEW_TYPE_DATA_HANDLE) {
                this.tabList.push(tab)

                this.dataHandleOpts.item = tab
                this.dataHandleMap[tab.viewId] = clone(this.dataHandleOpts)
              }
            })
            if (saveJumpInfo) {
              this.tabActive = saveJumpInfo.tabActive
            } else {
              this.tabActive = this.tabList[0] ? this.tabList[0].viewId : ''
            }
            this.canApplyForm = res.some(item => item.viewType === FORM_VIEW_TYPE_WRITE_FORM)
            return res
          }
        })
          .then(() => {
            let dataHandleOpts = this.dataHandleMap[this.tabActive]
            if (saveJumpInfo) {
              dataHandleOpts.filter = saveJumpInfo.filter
              dataHandleOpts.sort = saveJumpInfo.sort
              dataHandleOpts.currentPage = saveJumpInfo.currentPage
              dataHandleOpts.allPreData = 1
              dataHandleOpts.scrollTop = saveJumpInfo.scrollTop
            }
            this.fetchApplyHeader(dataHandleOpts)
          })
          .catch(console.error)
      }

    },
    computed: {
      sortFields() {
        console.log(this.dataHandleOpt().header)
        return this.dataHandleOpt().header.filter(item => item.type !== FORM_ITEM__BUTTON && item.type !== FORM_ITEM__RELATE_RECORD)
      }
    },
    methods: {
      dataHandleOpt() {
        console.log('this.dataHandleMap', this.dataHandleMap, this.tabActive, this.dataHandleMap[this.tabActive])
        return this.dataHandleMap[this.tabActive] || {}
      },
      async fetchFormDataPhoneStyle(dataHandleOpts, callback) {
        this.$store.dispatch('actionFormDataPhoneStyleGet', {
          formId: this.formId,
          viewId: this.tabActive
        }).then(res => {
          dataHandleOpts.styleInfo = res
          console.log('dataHandleOpts', dataHandleOpts)
          if (callback) callback()
        }).catch(console.error)
      },

      fetchApplyHeader(dataHandleOpts) {
        if (!dataHandleOpts.request) {
          if (dataHandleOpts.item.viewType === FORM_VIEW_TYPE_DATA_HANDLE) {
            this.$store.dispatch('actionApplyHeader', {formId: this.formId})
              .then((res = []) => {
                dataHandleOpts.request = true
                dataHandleOpts.header = res.map(item => {
                  return {
                    ...item,
                    sort: 0,
                    show: true
                  }
                })
                this.fetchFormDataPhoneStyle(dataHandleOpts, () => {
                  this.getManagementData(dataHandleOpts)
                })
              }).catch(console.error)
          } else if (dataHandleOpts.item.viewType === FORM_VIEW_TYPE_DATA_VIEW) {

            this.$store.dispatch('actionFormDataViewHeader', {
              formId: this.formId,
              viewId: dataHandleOpts.item.viewId
            })
              .then((res = []) => {
                dataHandleOpts.request = true
                dataHandleOpts.header = res.map(item => {
                  return {
                    ...item,
                    sort: 0,
                    show: true
                  }
                })
                this.fetchFormDataPhoneStyle(dataHandleOpts, () => {
                  this.getManagementData(dataHandleOpts)
                })
              }).catch(console.error)
          }
        } else {
          if (!dataHandleOpts.styleInfo) {
            this.fetchFormDataPhoneStyle(dataHandleOpts, () => {
              this.getManagementData(dataHandleOpts)
            })
          }
          this.getManagementData(dataHandleOpts)
        }
      },
      // 获取数据管理数据
      getManagementData(dataHandleOpts) {
        if (dataHandleOpts.item.viewType === FORM_VIEW_TYPE_DATA_HANDLE) {
          this.$store.dispatch('actionApplyList', {
            formId: this.formId,
            currentPage: dataHandleOpts.currentPage + 1,
            pageSize: dataHandleOpts.pageSize,
            allPreData: dataHandleOpts.allPreData,
            sort: dataHandleOpts.sort,
            filter: this.dataFilter
          }).then(({currentPage, dataList, totalPage, totalCount, timestamp}) => {
            let showDataList = []
            dataList.forEach(item => {
              let showData = {
                title: {},
                color: {},
                time: {},
                image: {},
                content: [],
                item
              }
              if (dataHandleOpts.styleInfo.showTitle) {
                showData.title = {
                  showData: item[dataHandleOpts.styleInfo.titleFieldId],
                  fieldId: dataHandleOpts.styleInfo.titleFieldId,
                  type: 'title'
                }
              }
              // 卡片颜色
              if (dataHandleOpts.styleInfo.showColor === 1) {
                // 获取当前选择的选项的id
                const optId = item[dataHandleOpts.styleInfo.colorFieldId]
                const field = dataHandleOpts.header.filter(field => field.dataId === dataHandleOpts.styleInfo.colorFieldId)[0]
                let opt = null
                if (field) {
                  opt = field.options.filter(opt => opt.id === optId)[0]
                }
                showData.color = {
                  showData: opt ? opt.color : '',
                  fieldId: dataHandleOpts.styleInfo.colorFieldId,
                  type: 'color'
                }
              }
              // 时间
              if (dataHandleOpts.styleInfo.showTime) {
                showData.time = {
                  showData: item[dataHandleOpts.styleInfo.timeFieldId],
                  fieldId: dataHandleOpts.styleInfo.timeFieldId,
                  type: 'title'
                }
              }
              // 图片
              if (dataHandleOpts.styleInfo.showImage) {
                if (dataHandleOpts.styleInfo.imageFieldId.includes('IMAGE_')) {
                  const imgArr = item[dataHandleOpts.styleInfo.imageFieldId]
                  showData.image = {
                    showData: imgArr && imgArr.length > 0 ? imgArr[0].imgUrl : '',
                    fieldId: dataHandleOpts.styleInfo.imageFieldId,
                    type: 'title'
                  }
                } else {
                  showData.image = {
                    showData: item[dataHandleOpts.styleInfo.imageFieldId],
                    fieldId: dataHandleOpts.styleInfo.imageFieldId,
                    type: 'title'
                  }
                }

              }

              dataHandleOpts.styleInfo.showFieldList.forEach(fieldId => {
                let field = dataHandleOpts.header.filter(field => field.dataId === fieldId)[0]
                if (field) {
                  showData.content.push({
                    showData: item[fieldId],
                    type: field.type,
                    ...field
                  })
                }
              })
              showDataList.push(showData)
            })
            dataHandleOpts.dataList.push(...showDataList)
            dataHandleOpts.totalPage = totalPage
            dataHandleOpts.currentPage = currentPage
            dataHandleOpts.totalCount = totalCount
            if (totalPage <= currentPage) {
              this.finished = true
            }
            console.log('dataList', dataHandleOpts.dataList)
            this.refreshRelateData(dataHandleOpts)
          })
            .catch(console.error)
            .finally(() => {
              this.loadingEnd = true
              this.loading = false
              if (this.toast) this.toast.clear()
              dataHandleOpts.allPreData = 0
              this.scrollToLocation()
            })

        } else if (dataHandleOpts.item.viewType === FORM_VIEW_TYPE_DATA_VIEW) {

          this.$store.dispatch('actionFetchFormViewDetail', {
            formId: this.formId,
            viewId: dataHandleOpts.item.viewId
          }).then(res => {
            this.viewSet = res
            return this.$store.dispatch('actionFormDataViewData', {
              formId: this.formId,
              viewId: dataHandleOpts.item.viewId,
              currentPage: dataHandleOpts.currentPage + 1,
              pageSize: dataHandleOpts.pageSize,
              allPreData: dataHandleOpts.allPreData,
              sortList: Object.keys(dataHandleOpts.sort).map(key => {
                return {
                  fieldId: key,
                  sortType: dataHandleOpts.sort[key]
                }
              }),
              filter: dataHandleOpts.filter
            })
          })
            .then(({currentPage, dataList, totalPage, totalCount, timestamp}) => {
              let showDataList = []
              dataList.forEach(item => {
                let showData = {
                  title: {},
                  color: {},
                  time: {},
                  image: {},
                  content: [],
                  item
                }
                if (dataHandleOpts.styleInfo.showTitle) {
                  showData.title = {
                    showData: item[dataHandleOpts.styleInfo.titleFieldId],
                    fieldId: dataHandleOpts.styleInfo.titleFieldId,
                    type: 'title'
                  }
                }
                // 卡片颜色
                if (dataHandleOpts.styleInfo.showColor === 1) {
                  // 获取当前选择的选项的id
                  const optId = item[dataHandleOpts.styleInfo.colorFieldId]
                  const field = dataHandleOpts.header.filter(field => field.dataId === dataHandleOpts.styleInfo.colorFieldId)[0]
                  let opt = null
                  if (field) {
                    opt = field.options.filter(opt => opt.id === optId)[0]
                  }
                  showData.color = {
                    showData: opt ? opt.color : '',
                    fieldId: dataHandleOpts.styleInfo.colorFieldId,
                    type: 'color'
                  }
                }
                // 时间
                if (dataHandleOpts.styleInfo.showTime) {
                  showData.time = {
                    showData: item[dataHandleOpts.styleInfo.timeFieldId],
                    fieldId: dataHandleOpts.styleInfo.timeFieldId,
                    type: 'title'
                  }
                }
                // 图片
                if (dataHandleOpts.styleInfo.showImage) {
                  if (dataHandleOpts.styleInfo.imageFieldId.includes('IMAGE_')) {
                    const imgArr = item[dataHandleOpts.styleInfo.imageFieldId]
                    showData.image = {
                      showData: imgArr && imgArr.length > 0 ? imgArr[0].imgUrl : '',
                      fieldId: dataHandleOpts.styleInfo.imageFieldId,
                      type: 'title'
                    }
                  } else {
                    showData.image = {
                      showData: item[dataHandleOpts.styleInfo.imageFieldId],
                      fieldId: dataHandleOpts.styleInfo.imageFieldId,
                      type: 'title'
                    }
                  }

                }

                dataHandleOpts.styleInfo.showFieldList.forEach(fieldId => {
                  let field = dataHandleOpts.header.filter(field => field.dataId === fieldId)[0]
                  if (field) {
                    let value = item[fieldId]
                    if (dataHandleOpts.item.viewType === FORM_VIEW_TYPE_DATA_VIEW &&
                      this.viewSet &&
                      this.viewSet.partHiddenFieldList &&
                      this.viewSet.partHiddenFieldList.length &&
                      this.viewSet.partHiddenFieldList.includes(fieldId)) {
                      if (isPhone(value)) {
                        value = hiddenStr(value, 3, 4)
                      } else if (isIDCard(value)) {
                        value = hiddenStr(value, 6, 4)
                      } else if (value.length > 2) {
                        value = hiddenStr(value, 1, 1)
                      }
                    }
                    if (field.type === FORM_ITEM__MEMBER) {
                      showData.content.push({
                        showData: item[fieldId],
                        showType: this.dataHandleOpt().styleInfo.memberShowType,
                        type: field.type,
                        ...field
                      })
                    } else {
                      showData.content.push({
                        showData: value,
                        type: field.type,
                        ...field
                      })
                    }
                  }
                })
                showDataList.push(showData)
              })
              dataHandleOpts.dataList.push(...showDataList)
              dataHandleOpts.totalPage = totalPage
              dataHandleOpts.currentPage = currentPage
              dataHandleOpts.totalCount = totalCount
              if (totalPage <= currentPage) {
                this.finished = true
              }
              this.refreshRelateData(dataHandleOpts)
            }).catch(console.error)
            .finally(() => {
              this.loadingEnd = true
              this.loading = false
              if (this.toast) this.toast.clear()
              dataHandleOpts.allPreData = 0
              this.scrollToLocation()
            })
        }

      },

      refreshRelateData(dataHandleOpts) {
        const relateFieldList = []
        dataHandleOpts.styleInfo.showFieldList.forEach(fieldId => {
          let field = dataHandleOpts.header.filter(field => field.dataId === fieldId)[0]
          if (field && field.type === FORM_ITEM__RELATE_RECORD) {
            relateFieldList.push(field)
          }
        })
        relateFieldList.forEach(field => {

          const instanceIdList = []
          dataHandleOpts.dataList.forEach(item => {
            const value = item.content.filter(c => c.dataId === field.dataId)[0]
            if (value && value.showData) {
              instanceIdList.push(...value.showData.instanceIdList)
            }
          })

          Promise.all([
            this.$store.dispatch('actionLiteMergeStructure', {
              appId: field.relateAppId,
              formId: field.relateFormId,
            }),
            this.$store.dispatch('actionApplyBatch', {
              appId: field.relateAppId,
              formId: field.relateFormId,
              instanceIdList
            })
          ]).then(([structure, res]) => {

            let showDataMap = {}
            res.dataList.forEach((item, idx) => {
              let showData = {
                title: '',
                ...item
              }
              // 处理title
              if (field.titleFieldId) {
                const relateField = structure.detailInfo.fieldList.filter(item => item.dataId === field.titleFieldId)[0]
                let val = item[field.titleFieldId]
                console.log('relateField', relateField, field.titleFieldId, structure.detailInfo.fieldList)
                if (relateField.type === FORM_ITEM__DATE) {
                  let format = 'yyyy-MM-dd'
                  if (relateField.dateType === DATE_TYPE__SECTION) {
                    format = 'yyyy-MM-dd HH:mm'
                  }
                  val = item[field.titleFieldId] ? formatDate(item[field.titleFieldId])(format) : ''
                }
                showData.title = val
              }
              showDataMap[item.instanceId] = showData
            })

            dataHandleOpts.dataList.forEach(item => {
              const value = item.content.filter(c => c.dataId === field.dataId)[0]
              if (value && value.showData) {
                value.key = Math.random()
                value.showData.showTitleList.splice(0, value.showData.showTitleList.length)
                value.showData.instanceIdList.forEach(instanceId => {
                  if (showDataMap[instanceId]) {
                    value.showData.showTitleList.push(showDataMap[instanceId])
                  }
                })
              }
            })
            console.log('dataList---', dataHandleOpts.dataList)
            this.listKey = Math.random()
          })
            .catch(console.error)
        })
      },

      scrollToLocation() {
        this.$nextTick(() => {
          if (this.dataHandleOpt().scrollTop > 0) {
            const pageContainer = document.getElementById(`listContainer_${this.tabActive}`);
            if (pageContainer) pageContainer.scrollTop = this.dataHandleOpt().scrollTop
            this.dataHandleOpt().scrollTop = 0
          }
        })
      },
      // 标签被点击
      onClickTab(name, title) {
        this.loadingEnd = false
        this.finished = false
        let dataHandleOpts = this.dataHandleMap[name]
        dataHandleOpts.dataList.splice(0, dataHandleOpts.dataList.length)
        dataHandleOpts.currentPage = 0
        dataHandleOpts.totalPage = 0
        dataHandleOpts.totalCount = 0
        dataHandleOpts.filter = null
        dataHandleOpts.sort = {}
        console.log(dataHandleOpts)
        this.fetchApplyHeader(dataHandleOpts)
      },

      // 加载更多数据
      onLoad() {
        console.log('onLoad', this.loading)
        let dataHandleOpts = this.dataHandleMap[this.tabActive]
        this.getManagementData(dataHandleOpts)
      },
      actionFormatTime(d) {
        return formatDate(d)('yyyy-MM-dd HH:mm')
      },

      // 表格行被点击
      rowClick(row) {
        console.log('row', row)
        const viewItem = this.dataHandleMap[this.tabActive].item

        let showFields = []
        this.dataHandleOpts.selectList.forEach(item => {
          if (item.show) {
            showFields.push(item.dataId)
          }
        })

        let index = 0
        for (let i = 0; i < this.dataHandleOpt().dataList.length; i++) {
          if (this.dataHandleOpt().dataList[i].item.instanceId === row.item.instanceId) {
            index = i
            break
          }
        }

        // 存信息，返回回来需要定位
        const pageContainer = document.getElementById(`listContainer_${this.tabActive}`)
        const saveJumpInfo = {
          tabActive: this.tabActive,
          scrollTop: pageContainer ? pageContainer.scrollTop : 0,
          filter: this.dataHandleOpt().filter,
          sort: this.dataHandleOpt().sort,
          currentPage: this.dataHandleOpt().currentPage - 1
        }
        sessionStorage.setItem('saveJumpInfo', JSON.stringify(saveJumpInfo));

        if (viewItem.viewType === FORM_VIEW_TYPE_DATA_HANDLE) {
          const param = {
            instanceId: row.item.instanceId,
            showFields,
            appId: this.$store.getters.currentAppId,
            formId: this.formId,
            index,
            dataList: this.dataHandleOpt().dataList
          }
          const toast = this.$toast.loading({
            message: '加载中...'
          })
          this.$store.dispatch('reqNodeSave', param).then(res => {
            this.$router.push({
              name: 'formDataDetail',
              query: {
                key: res.nodeKey
              }
            })
          })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })

        } else if (viewItem.viewType === FORM_VIEW_TYPE_DATA_VIEW) {
          const param = {
            instanceId: row.item.instanceId,
            showFields,
            stepId: row.item.stepId,
            viewId: this.tabActive,
            appId: this.$store.getters.currentAppId,
            formId: this.formId,
            index,
            dataList: this.dataHandleOpt().dataList
          }
          const toast = this.$toast.loading({
            message: '加载中...'
          })
          this.$store.dispatch('reqNodeSave', param).then(res => {
            this.$router.push({
              name: 'formViewDataDetail',
              query: {
                key: res.nodeKey
              }
            })
          })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        }
      },

      // 排序
      onClickSort() {
        this.sortVisible = true
      },

      // 升序
      ascending(item) {
        this.dataHandleOpt().header.forEach(item => {
          item.sort = 0
        })
        item.sort = 1
        this.sortVisible = false
        this.dataHandleOpt().sort = {
          [item.dataId]: 1
        }
        this.restartRequest()
      },

      // 降序
      descending(item) {
        this.dataHandleOpt().header.forEach(item => {
          item.sort = 0
        })
        item.sort = -1
        this.sortVisible = false
        this.dataHandleOpt().sort = {
          [item.dataId]: -1
        }
        this.restartRequest()
      },

      clearSort() {
        this.dataHandleOpt().header.forEach(item => {
          item.sort = 0
        })
        this.dataHandleOpt().sort = {}
        this.restartRequest()
        this.sortVisible = false
      },

      onClickFilter() {
        if (this.$refs.formDataFilter) {
          this.$refs.formDataFilter.open(this.dataHandleOpt().filter)
        }
      },

      // 筛选选择完成
      actionSelectFilterComplete(filter) {
        this.dataHandleOpt().filter = filter
        this.restartRequest()
      },

      restartRequest() {
        this.loadingEnd = false
        this.finished = false
        this.dataHandleOpt().dataList.splice(0, this.dataHandleOpt().dataList.length)
        this.dataHandleOpt().currentPage = 0
        this.dataHandleOpt().totalPage = 0
        this.dataHandleOpt().totalCount = 0

        this.fetchApplyHeader(this.dataHandleOpt())
      },

      // 发起表单
      onClickAddForm() {
        // 存信息，返回回来需要定位
        const pageContainer = document.getElementById(`listContainer_${this.tabActive}`)
        const saveJumpInfo = {
          tabActive: this.tabActive,
          scrollTop: pageContainer ? pageContainer.scrollTop : 0,
          filter: this.dataHandleOpt().filter,
          sort: this.dataHandleOpt().sort,
          currentPage: this.dataHandleOpt().currentPage - 1
        }
        sessionStorage.setItem('saveJumpInfo', JSON.stringify(saveJumpInfo));

        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('reqNodeSave', {
          appId: this.$store.getters.currentAppId,
          formId: this.formId
        })
          .then(res => {
            this.$router.push({
              name: 'formInput',
              query: {
                key: res.nodeKey
              }
            })
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            toast.clear()
          })
      }
    }
  }
</script>

<style lang="less">

  .form-data-container {
    height: calc(100% - env(safe-area-inset-bottom));
    overflow: hidden;

    .van-tabs {
      height: 100%;

      .van-tabs__content {
        height: calc(100% - 44px);

        .van-tab__pane {
          height: 100%;
        }
      }
    }

    .single-tabs {

      .van-tab {
        justify-content: left;
      }

      .van-tabs__line {
        transform: translateX(30px) translateX(-50%) !important;
      }
    }

    .header {
      height: 40px;
      background-color: #ffffff;
      /*border-top: 4px solid #F6F6F6;*/
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      border-bottom: 1px solid #e6e6e6;

      .des {
        color: #9f9f9f;
        font-size: 13px;
      }

      .van-icon {
        font-size: 20px;
        margin-left: 10px;
      }
    }

    .list-container {
      height: calc(100% - 40px);
      overflow: auto;
      -webkit-overflow-scrolling: touch;

      .photo-container {
        display: flex;
        flex-wrap: wrap;
      }

      .preview-container {

        .preview-card {
          margin: 10px;
          position: relative;
          width: calc(100% - 20px);
          background-color: #fff;
          display: flex;
          border-radius: 10px;
          border: 1px solid #ebeef5;
          overflow: hidden;
          color: #303133;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

          .color {
            width: 5px;
          }

          .preview-card-wrapper {
            display: flex;
            flex: 1 1;
            width: calc(100% - 5px);

            .card-info {
              flex: 1 1;
              width: calc(100% - 100px);
              border-radius: 2px;
              padding-left: 10px;

              h3 {
                height: 18px;
                font-size: 16px;
                font-weight: 700;
                color: #262626;
                line-height: 18px;
                margin: 10px 0 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              p {
                font-size: 13px;
                margin: 0;
                color: #959699;
              }

              .card-info-row {
                display: flex;
                flex: 1 1;
                margin-top: 10px;

                .row-item {
                  flex: 1 1;

                  h5 {
                    font-size: 11px;
                    color: #979797;
                    line-height: 16px;
                    margin: 0;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-wrap: break-word;
                  }

                  .item-content {
                    height: 31px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;

                    > div {
                      padding-left: 0;
                      padding-right: 0;
                      margin-right: 8px;
                      overflow: hidden;
                      flex-wrap: nowrap;
                      line-height: 24px;
                      flex-grow: 1;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                }
              }
            }

            .img-container {
              border-radius: 1px;
              /*border: 1px solid #f0f0f6;*/
              display: flex;
              justify-content: center;
              align-items: center;

              .van-image {
                width: 90px;
                height: 90px;
              }
            }
          }

        }

        .preview-photo {
          margin: 10px 5px;
          position: relative;
          width: calc(50% - 10px);
          background-color: #fff;
          border-radius: 10px;
          border: 1px solid #ebeef5;
          overflow: hidden;
          color: #303133;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

          .img-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 200px;

            .van-image {
              width: 100%;
              height: 200px;
            }
          }

          .card-info {
            padding: 10px 10px 0 10px;

            .title {
              display: flex;
              align-items: center;

              .color {
                width: 5px;
                height: 16px;
                margin-right: 5px;
              }

              h3 {
                height: 18px;
                font-size: 16px;
                font-weight: 700;
                color: #262626;
                line-height: 18px;
                margin: 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }


            p {
              font-size: 13px;
              margin: 0 0 10px 0;
              color: #959699;
            }

            .card-info-row {

              .row-item {
                flex: 1 1;
                margin: 10px 0;

                h5 {
                  font-size: 11px;
                  color: #979797;
                  line-height: 16px;
                  margin: 0;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  word-wrap: break-word;
                }

                .item-content {
                  height: 26px;
                  display: flex;
                  align-items: center;
                  color: #262626;
                  font-size: 14px;

                  > div {
                    padding-left: 0;
                    padding-right: 0;
                    margin-right: 8px;
                    overflow: hidden;
                    flex-wrap: nowrap;
                    line-height: 24px;
                    flex-grow: 1;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
        }
      }
    }

    .add-button {
      position: absolute;
      bottom: 40px;
      right: 20px;
      border-radius: 50%;
      width: 44px;
      height: 44px;
      padding: 0;
      background-color: #4A66FA;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }

  .select-sort-popup {
    height: 100%;

    .header {
      width: 100%;
      height: 30px;
      padding: 10px 20px;

      span {
        float: right;
        color: #05A971;
        font-size: 14px;
      }
    }

    .sort-container {
      height: calc(100% - 30px);
      overflow: auto;
      padding: 10px;

      .item-title {
        line-height: 30px;
        font-size: 16px;
        color: #333333;

        span {
          color: #4A66FA;
          font-size: 14px;
          margin-left: 10px;
        }
      }
    }
  }
</style>
